 
import API from "../../../../api/axiosClient";
import { SendPrivateMessageDto } from "../types/PrivateChat";

const baseUrl = "PrivateChat";

const getConversation = async (
    groupId: string
) => {

    const response = await API.get(
        `${baseUrl}/conversation/${groupId}`
    );

    return response.data;
};

const getMessages = async (
    conversationId: string
) => {

    const response = await API.get(
        `${baseUrl}/messages/${conversationId}`
    );

    return response.data;
};

const sendMessage = async (
    dto: SendPrivateMessageDto
) => {

    const response = await API.post(
        `${baseUrl}/send`,
        dto
    );

    return response.data;
};

const getCoordinatorGroups = async () => {

    const response = await API.get(
        `${baseUrl}/coordinator/groups`
    );

    return response.data;
};

const getCustomers = async (
    groupId: string
) => {

    const response = await API.get(
        `${baseUrl}/coordinator/groups/${groupId}/customers`
    );

    return response.data;
};
const getCoordinatorRequests = async () => {

    const response = await API.get(
         `${baseUrl}/coordinator`
    );

    return response.data;
};

const PrivateChatService = {

    getConversation,

    getMessages,

    sendMessage,

    getCoordinatorGroups,

    getCustomers,
    getCoordinatorRequests
};

export default PrivateChatService;